/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GeneralLookup } from '../models/GeneralLookup';
import type { SummaryTotal } from '../models/SummaryTotal';
import type { TopRider } from '../models/TopRider';
import type { UpcomingShow } from '../models/UpcomingShow';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardService {

    /**
     * API to upcoming shows
     * @returns UpcomingShow Success
     * @throws ApiError
     */
    public static dashboardGetUpcomingShows(): CancelablePromise<Array<UpcomingShow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/dashboard/upcomingShows',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to total counts of entity
     * @returns SummaryTotal Success
     * @throws ApiError
     */
    public static dashboardGetTotalSummary(): CancelablePromise<SummaryTotal> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/dashboard/totalSummary',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to user shows
     * @returns GeneralLookup Success
     * @throws ApiError
     */
    public static dashboardGetUserShows(): CancelablePromise<Array<GeneralLookup>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/dashboard/user/shows',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to get top point riders list of show
     * @param showId
     * @returns TopRider Success
     * @throws ApiError
     */
    public static dashboardGetTopRiders(
        showId?: string,
    ): CancelablePromise<Array<TopRider>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/dashboard/topRiders',
            query: {
                'showId': showId,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

}
